import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';

import NavigationBar from '../core/widgets/ui/NavigationBar';

import { useRecoilState } from 'recoil';
import { roleAtom } from '../core/config/atoms';

import Lottie from 'lottie-react';

import LayoutHome from 'layouts/LayoutHome';
import LayoutPartnerHome from 'layouts/LayoutPartnerHome';
import LayoutOutlet from 'layouts/LayoutOutlet';
import LayoutReport from 'layouts/LayoutReport';
import LayoutStaff from 'layouts/LayoutStaff';
import LayoutProfile from 'layouts/LayoutProfile';

import animPage from '../assets/anim/anim-pageload.json';

export default function PageHome() {

    const [rolsData] = useRecoilState(roleAtom);

    const [loading, setLoading] = useState(true);

    const { page } = useParams();

    const checkRole = () => {
        if (rolsData !== null && Object.keys(rolsData).length !== 0) {
            setLoading(false);
        }
    }

    useEffect(() => {
        checkRole();
    }, [rolsData]);

    return (
        <>
            {
                loading && <div className='flex items-center justify-center w-full h-full'>
                    <Lottie animationData={animPage} className="w-40 h-40" loop={true} />
                </div>
            }
            {
                !loading && <div className='w-full h-screen overflow-hidden flex relative'>
                    <NavigationBar />
                    <div className='w-full h-screen overflow-hidden flex relative'>
                        {(() => {
                            switch (page) {
                                case 'home':
                                    if (rolsData.role === "PARTNER") {
                                        return (<LayoutPartnerHome />);
                                    } else {
                                        return (<LayoutHome />);
                                    }
                                case 'outlet':
                                case 'orgInfo':
                                case 'outletInfo':
                                    return (<LayoutOutlet />);
                                case 'reports':
                                case 'trns':
                                case 'task':
                                    return (<LayoutReport />);
                                case 'staff':
                                    return (<LayoutStaff />);
                                case 'profile':
                                    return (<LayoutProfile />);
                                default:
                                    return (
                                        <div className="w-full h-full text-5xl flex items-center justify-center" style={{ height: "80vh" }}>
                                            In Development Mode
                                        </div>
                                    );
                            }
                        })()}
                    </div>
                </div>
            }
        </>
    )
}
